import type { BookingResponse, QuotationResponse, TripResult, AncillarySelectionInput } from '@cvo/domain';
/**
 * Composable for managing quotation operations.
 * Handles quotation creation for selected trips.
 */
export function useQuotation() {
  const api = useApi();
  const subscriptionStore = useSubscriptionStore();

  const quotation = ref<QuotationResponse>();
  const bookingDraft = ref<BookingResponse>();

  const hasQuotation = computed(() =>!!quotation.value);

  function createQuotation(availabilityId: string, outboundId: TripResult['id'], inboundId?: TripResult['id'], ancillaries?: AncillarySelectionInput[]) {
    return api.booking.createQuotation(subscriptionStore.selectedSubscriptionId!, {
      availabilityId,
      outboundId,
      inboundId,
      ancillaries,
    }).then(({ data }) => {
        quotation.value = data;
        return data;
      })
      .catch((err) => {
        quotation.value = undefined;
        throw err;
      });
  }

  function createBookingDraft() {
    if (!quotation.value) {
      throw new Error('No quotation available to create a booking draft.');
    }

    return api.booking.createBooking(subscriptionStore.selectedSubscriptionId!, quotation.value!.id)
      .then(({ data }) => {
        bookingDraft.value = data;
        return data;
      })
      .catch((err) => {
        bookingDraft.value = undefined;
        throw err;
      });
  }

  return {
    quotation,
    hasQuotation,
    bookingDraft,
    // Methods
    createQuotation,
    createBookingDraft,
  };
}